import { Capacitor } from '@capacitor/core';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getConfig } from '../../appConfig';
import { Title } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { withTranslation } from '../../lib/translate';
import './index.css';
import 'moment-timezone';
import SquarePayButtons from '../../components/squarePayButtons';
import { createSquareSubscription } from '../../store/actions';
import { forwardTo } from '../../lib/utils';

const isWeb = () => Capacitor.getPlatform() === 'web';

const SubscriptionCheckout = ({ __ }) => {
	const dispatch = useDispatch();
	const historyLocation = useLocation();
	const [homeLocationId, setHomeLocationId] = useState(null);
	const [packageId, setPackageId] = useState(null);
	const restaurants = useSelector((state) => state.restaurants.restaurants);
	const selectedSubscription = useSelector((state) => state.orders.selectedSubscription);
	const subscriptions = useSelector((state) => state.subscription.subscriptions);

	if(!selectedSubscription){
		forwardTo('/membership');
	}

	useEffect(() => {
		const homeLocationIdFromState = historyLocation?.state?.homeLocationId || null;
		const packageIdFromState = historyLocation?.state?.selectedSubscriptionId || null;
		setHomeLocationId(homeLocationIdFromState);
		setPackageId(packageIdFromState);
	}, [historyLocation]);

	const createSubscription = (paymentData) => {
		dispatch(createSquareSubscription({ paymentData, packageId, homeLocationId }));	
	};

	const restaurant = restaurants?.find((restaurant) => restaurant?.business_location_id === 'subscriptions') || {};
	const selectedSubscriptionPackage = subscriptions?.find((subscription) => subscription.id === selectedSubscription?.id) || {};
	const price = (selectedSubscriptionPackage?.monthly_cost_inc_vat / 100) || 0;

	return (
		<Loading transparent>
			<Layout color="transparent" headerWithTitle={true} title={__('Checkout')}>
				<div className="flex-row-wrapper absolute-content">
					<Title className="web-only page-title-centered">{__('Checkout')}</Title>
					{getConfig()?.squarePayment?.enabled ?
						<SquarePayButtons
							__={__}
							createOrderCb={createSubscription}
							autoSaveCard={true}
							restaurant={restaurant}
							totalPrice={price}
							hideApplePay={true}
							hideGooglePay={true}
						/>
						: <>
							{null}
						</>}
				</div>
			</Layout>
		</Loading>
	);
};

const mapStateToProps = (store) => {
	return {
		cards: store.orders.cards || [],
		profile: store.profile.profile || {},
		clientSecret: store.orders.clientSecret,
		deliveryTimeModalOpen: store.common.deliveryTimeModalOpen,
		restaurants: store.restaurants.restaurants || [],
	};
};

export default connect(mapStateToProps)(withTranslation(SubscriptionCheckout));
